// statusMap.js
import { FiInbox, FiLoader, FiCheckCircle, FiSlash, FiCreditCard, FiFileText } from "react-icons/fi"

export const STATUS_MAP = {
  OPN: {
    label: "Open",
    badge: "badge rounded-pill bg-info text-dark",
    code: "OPN",
    icon: <FiInbox size={18} />,
  },
  INP: {
    label: "In Progress",
    badge: "badge rounded-pill bg-warning text-dark",
    code: "INP",
    icon: <FiLoader size={18} className="spin-slow" />,
  },
  CRS: {
    label: "Resolved",
    badge: "badge rounded-pill bg-success",
    code: "CRS",
    icon: <FiCheckCircle size={18} />,
  },
  CNR: {
    label: "No Response",
    badge: "badge rounded-pill bg-secondary",
    code: "CNR",
    icon: <FiSlash size={18} />,
  },
  INV: {
    label: "Invoiced",
    badge: "badge bg-success",
    icon: <FiCreditCard size={18} />,
  },
  NIV: {
    label: "Not Invoiced",
    badge: "badge bg-warning text-dark",
    icon: <FiFileText size={18} />,
  },
}
